<template>
  <svg class="icon" aria-hidden="true">
    <use :xlink:href="`#icon-${name}`"></use>
  </svg>
</template>

<script setup>
defineProps({
  name: {
    type: String,
    required: true
  }
})
</script>

<style scoped>
.icon {
  width: 1em;
  height: 1em;
  fill: currentColor; /* 继承文字颜色 */
  vertical-align: -0.15em;
}
</style>
